import React, { FunctionComponent, useContext } from 'react';
import GameContext from '../../context/GameContext';
import { CharacterSeed } from '../../views/avatar/Avatar';

interface CharacterProps {
    seed?: CharacterSeed;
    name?: string;
}

const Character: FunctionComponent<CharacterProps> = ({ seed, name }) => {
    const { avatarSeed } = useContext(GameContext);

    const skin = seed?.skin || avatarSeed.skin;
    const color = seed?.color || avatarSeed.color;
    const genre = seed?.genre || avatarSeed.genre;

    return (
        <div className={`character ${skin}-${color}-${genre}`}>
            {name && (
                <div className="name">
                    <span>{name}</span>
                </div>
            )}
        </div>
    );
};

export default Character;
